class Accordion extends HTMLElement {
  constructor() {
    super();
    this.isAnimating = false; // Variable para rastrear si hay una animación en curso
  }
  
  connectedCallback() {
    this.addEventListener("click", (e) => {
      const titleElement = e.target.closest("[data-title]");
      if (titleElement && !this.isAnimating) {
        this.toggleContent(titleElement);
      }
    });
  }

  toggleContent(titleElement) {
    // Establecer la bandera de animación
    this.isAnimating = true;
    
    const articleElement = titleElement.closest("article");
    const contentElement = articleElement.querySelector("[data-content]");
    const isActive = articleElement.classList.contains("--active");
    const currentActive = this.querySelector("article.--active");

    // Cerrar el acordeón activo si existe y es diferente
    if (currentActive && currentActive !== articleElement) {
      const activeContent = currentActive.querySelector("[data-content]");
      activeContent.style.height = activeContent.scrollHeight + "px";
      void activeContent.offsetHeight;
      activeContent.style.height = "0px";
      currentActive.classList.remove("--active");
    }

    // Toggle del estado actual
    if (isActive) {
      contentElement.style.height = contentElement.scrollHeight + "px";
      void contentElement.offsetHeight;
      contentElement.style.height = "0px";
      
      setTimeout(() => {
        articleElement.classList.remove("--active");
        
        // Liberar la bandera de animación después de completar
        setTimeout(() => {
          this.isAnimating = false;
        }, 50);
      }, 10);
    } else {
      articleElement.classList.add("--active");
      contentElement.style.height = "auto";
      const height = contentElement.scrollHeight;
      contentElement.style.height = "0px";
      void contentElement.offsetHeight;
      contentElement.style.height = height + "px";
      
      // Liberar la bandera de animación después de la duración de la transición
      setTimeout(() => {
        contentElement.style.height = "auto";
        this.isAnimating = false;
      }, 550); // Un poco más que la duración de la transición
    }
  }
}

customElements.define("c-accordion", Accordion);